export default class PaginationRequestData {
  public page = 1
  public limit = 10
  public ascending = 0
  public order_by: string | null = null
}
